import React, { FC, useState } from 'react';
import { useCreateCommentNoteEntry } from '../../../../hooks/api/Property/useCreateCommentNoteEntry';
import { createPropertyComments } from '../../../../api/Property/createPropertyComments';

type AddNoteFormProps = {
  propertyId: string;
  commentData: any;
  refetchCommentData: () => void;
}

const MAX_LENGTH = 1000;

const AddNoteForm: FC<AddNoteFormProps> = ({ propertyId, commentData, refetchCommentData }) => {
  const [ body, setBody ] = useState('');
  const [ isSubmitting, setIsSubmitting ] = useState(false);
  const { mutateAsync: createNoteEntry } = useCreateCommentNoteEntry();

  const handleSubmit = async () => {
    if (!body.trim() || isSubmitting) return;
    setIsSubmitting(true);

    try {
      let commentId = commentData?.comment?.id;

      if (!commentId) {
        const form = new FormData();
        form.append('comment[title]', '');
        form.append('comment[notes]', '');
        const response = await createPropertyComments(propertyId, form);
        commentId = response?.data?.comment?.id;
      }

      if (commentId) {
        await createNoteEntry({ property_id: propertyId, comment_id: commentId, body: body.trim() });
        setBody('');
      }

      await refetchCommentData();
    } catch (error) {
      console.error('Error adding note:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className='mb-6'>
      <h3 className='text-lg font-semibold text-gray-900 mb-2'>Add a Note</h3>
      <textarea
        value={body}
        maxLength={MAX_LENGTH}
        onChange={(e) => setBody(e.target.value)}
        placeholder='Write your detailed note...'
        className='w-full h-32 rounded-lg border border-gray-300 p-3 focus:outline-none focus:ring focus:ring-indigo-300'
      />
      <div className='flex items-center justify-between mt-2'>
        <span className='text-sm text-gray-500'>{body.length} / {MAX_LENGTH} characters</span>
        <button
          type='button'
          disabled={!body.trim() || isSubmitting}
          onClick={handleSubmit}
          className='rounded-md px-4 py-2 text-sm font-semibold text-white bg-indigo-600 hover:bg-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed'
        >
          {isSubmitting ? 'Saving...' : '+ Add Note'}
        </button>
      </div>
    </div>
  );
};

export default AddNoteForm;
